import { FC, HTMLProps } from 'react';
import PropTypes from 'prop-types';
import * as icons from '../icons';

type IconKeys = keyof typeof icons; // Strictly type the keys of the icons object

const Icon: FC<HTMLProps<SVGElement> & {
  icon: IconKeys; // Use IconKeys for strict typing
  tabIndex?: number;
  viewBox?: string | undefined;
}> = ({ icon, ...props }) => {
  const IconComponent = icons[icon];
  if (!IconComponent) {
    throw new Error(`Icon "${icon}" does not exist in the icon set.`);
  }
  return <IconComponent {...props} />;
};

Icon.propTypes = {
  /**
   * Icon to render from the icon set
   */
  icon: PropTypes.oneOf(Object.keys(icons) as IconKeys[]).isRequired,
};

export const iconPropType = PropTypes.oneOf(Object.keys(icons) as IconKeys[]);
export default Icon;
